import { render, staticRenderFns } from "./communication-notification.vue?vue&type=template&id=8784724e"
import script from "./communication-notification.vue?vue&type=script&lang=js"
export * from "./communication-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports